import { render } from "./UniversalTable.vue?vue&type=template&id=23ce8ca8&scoped=true"
import script from "./UniversalTable.vue?vue&type=script&lang=js"
export * from "./UniversalTable.vue?vue&type=script&lang=js"

import "./UniversalTable.vue?vue&type=style&index=0&id=23ce8ca8&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/Portal/portal-partner-cicd-staging@2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ce8ca8"]])

export default __exports__